import * as React from 'react';

import { Typography } from '@mui/material';
import { MainHeader } from '@/layout';

export function NotFoundComponent() {
  return (
    <div className="h-dvh flex flex-col">
      <MainHeader />
      <div className="text-center flex flex-1 flex-col items-center justify-center relative overflow-hidden">
        <img
          src="/assets/images/404/circle-small.svg"
          className="absolute gentle-1 min-w-[350px] w-[350px] sm:min-w-[680px] sm:w-[680px]"
          alt="Rotating decorative small circle"
          aria-hidden="true"
        />
        <img
          src="/assets/images/404/circle-medium.svg"
          className="absolute gentle-2 min-w-[500px] w-[500px] sm:min-w-[1100px] sm:w-[1100px]"
          alt="Rotating decorative mediuml circle"
          aria-hidden="true"
        />
        <img
          src="/assets/images/404/circle-big.svg"
          className="absolute gentle-3 min-w-[650px] w-[650px] sm:min-w-[1520px] sm:w-[1520px]"
          alt="Rotating decorative big circle"
          aria-hidden="true"
        />
        <img
          src="/assets/images/404/circle-medium.svg"
          className="absolute gentle-4 min-w-[800px] w-[800px] sm:min-w-[2140px] sm:w-[2140px] opacity-50"
          alt="Rotating decorative medium circle"
          aria-hidden="true"
        />

        <div className="max-w-[600px] py-24 px-4 md:px-8 lg:px-10 xl:px-[80px] z-10">
          <div className="pb-4 md:pb-8">
            <Typography variant="mac-sans-h3" className="sm:mb-2 text-center" component="h2">
              Ops… nota stonata!
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
}
